export default __webpack_public_path__ + "static/media/designandart-min.b7cc7205.png";